// extracted by mini-css-extract-plugin
export default {"container":"GraphQuestion__container___nP96J","headerContainer":"GraphQuestion__headerContainer___JN_uz","leftContainer":"GraphQuestion__leftContainer___BjIiY"};